export default __webpack_public_path__ + "static/media/clientImg4.9fc87a1c.png";